import { motion } from "framer-motion";
import { ROLE_COLORS, roleOf } from "@/lib/roles";
import { labelDims } from "@/lib/labels";

const EASE = [0.25, 1, 0.5, 1];

const StillG = ({ animate, initial, transition, onPointerDown, style, children, ...rest }) => (
  <g transform={`translate(${animate.x} ${animate.y})`} {...rest}>{children}</g>
);

export const Defender = ({ pos, pt, job, label, size, showLabel, labelOffset, instant, selected, editable, onGrab, still }) => {
  const r = size;
  const { ls, w } = labelDims(label, size);
  const color = ROLE_COLORS[roleOf(job)];
  const [dx, dy] = labelOffset || [0, r + ls * 0.95];
  const G = still ? StillG : motion.g;
  return (
    <G
      data-testid={`defender-${pos.toLowerCase()}`}
      data-job={job}
      initial={false}
      animate={{ x: pt[0], y: -pt[1] }}
      transition={{ duration: instant ? 0 : 0.8, ease: EASE }}
      style={{ pointerEvents: editable ? "auto" : "none", cursor: editable ? "grab" : "default" }}
      onPointerDown={editable ? (e) => { e.stopPropagation(); onGrab(pos, e); } : undefined}
    >
      {selected && <circle r={r * 1.55} fill="none" stroke="#facc15" strokeWidth={r * 0.22} strokeDasharray={`${r * 0.5} ${r * 0.3}`} />}
      {editable && <circle r={r * 1.8} fill="transparent" />}
      <circle r={r * 1.18} fill="#0b1220" opacity="0.35" cy={r * 0.12} />
      <circle r={r} fill={color} stroke="#fff" strokeWidth={r * 0.16} style={{ transition: "fill 300ms ease" }} />
      <text textAnchor="middle" dominantBaseline="central" fontSize={size * 0.62} fontWeight="800" fill="#fff" className="font-heading">
        {pos}
      </text>
      {showLabel && (
        <G initial={false} animate={{ x: dx, y: dy }} transition={{ duration: instant ? 0 : 0.8, ease: EASE }}>
          <rect x={-w / 2} y={-ls * 0.72} width={w} height={ls * 1.44} rx={ls * 0.4} fill="#0b1220" opacity="0.88" />
          <text data-testid={`defender-label-${pos.toLowerCase()}`} textAnchor="middle" dominantBaseline="central" fontSize={ls} fontWeight="700" fill="#fff">
            {label}
          </text>
        </G>
      )}
    </G>
  );
};
